import { render, staticRenderFns } from "./card-insurance-details.vue?vue&type=template&id=24adabba&"
import script from "./card-insurance-details.vue?vue&type=script&lang=js&"
export * from "./card-insurance-details.vue?vue&type=script&lang=js&"
import style0 from "./card-insurance-details.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports